'use strict';

export function init() {
    const articleHeader = document.querySelector('.js-article-header');
    const eventInline = document.querySelector('.event-inline');
    const eventInlineSticky = document.querySelector('.event-inline--sticky');
    const contentBlocks = document.querySelector('.content-blocks');

    if (articleHeader && eventInlineSticky && contentBlocks && eventInline) {
        const myScrollFunc = function() {
            const contentRect = contentBlocks.getBoundingClientRect();
            const eventRect = eventInline.getBoundingClientRect();
            const triggerPoint = window.innerHeight / 2;

            const eventInlineVisible = (
                eventRect.top < window.innerHeight && eventRect.bottom >= 0
            );

            if (eventInlineVisible) {
                eventInlineSticky.classList.remove('show');
            } else if (contentRect.top <= triggerPoint) {
                eventInlineSticky.classList.add('show');
            } else {
                eventInlineSticky.classList.remove('show');
            }
        };

        window.addEventListener('scroll', myScrollFunc, { passive: true });
    }
}
